import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, signal } from '@angular/core';

@Component({
  standalone: true,
  selector: 'tt-tab-group',
  template: '<ng-content/>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabGroupComponent {
  @HostBinding('class.tt-tab-group') public hostCls = true;

  private _selected = signal(undefined);
  @Input() public set selected(value) {
    this._selected.set(value);
  }

  @Output() public tabSelected = new EventEmitter();
}
